import React from 'react';
import { Carousel } from 'react-bootstrap'
import { Scrollbars } from 'react-custom-scrollbars';

class News extends React.Component {

    render() {

        let news = (
			<div className="login-box-news-loading">
            	<h4>Loading News, please wait...</h4>
            	<img src="/images/loading.gif" alt="Please wait..." />
			</div>);

        if (this.props.content.length > 0) {
            var items = [];
            this.props.content.forEach((e, i) => {
               
                items.push(
                    <Carousel.Item key={i}>
                        <Scrollbars style={{ height: 290, width: 360 }} autoHide   >
                            <div className="login-box-news-heading animated fadeIn"  key={i} >
                                <div dangerouslySetInnerHTML={{ __html: e.content }} />
                            </div>
                        </Scrollbars>
                    </Carousel.Item>
                );
            });

            news =
                <div className="login-box-news-body" >
                <Carousel 
                    indicators={false} 
                    controls={false} 
                    pauseOnHover={true} 
                    interval={8000}>
                        {items}
                    </Carousel>
                </div>;
        }

        return (
            <React.Fragment>
                {news}
            </React.Fragment>
        );
    }
}

export default News;



// WEBPACK FOOTER //
// ./src/areas/public/login/News.js